import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import Input from './Input';
import ui from '../../services/ui';

const Select = ({ name, label, data, horizontal, hideEmptyOption, emptyLabel, onChange, ...props }) => {
	return (
		<Field name={name} component={Input} horizontal={horizontal} componentClass='select' label={label} onChange={onChange} {...props}>
			{hideEmptyOption || (emptyLabel ? <option key='' value=''>{emptyLabel}</option> : <option />)}
			{ui.makeOptionValues(data)}
		</Field>
	);
};

Select.propTypes = {
	horizontal: PropTypes.bool,
	name: PropTypes.string,
	label: PropTypes.string,
	data: PropTypes.oneOfType([ PropTypes.object, PropTypes.array])
};

export default Select;